<template>
<section id="signin">
    <NavbarDefault />
    <div class="container-fluid layout d-flex flex-column justify-content-center">
        <div class="row">
            <div class="col d-flex flex-column justify-content-center p-0">
                <div class="width-432 mx-auto my-3">
                    <h2 :class="`c-${getPrimaryColor}four`">Login</h2>
                    <p>Entre na plataforma com os seus dados cadastrais.</p> 
                    <el-form @keydown.native="invalidCredetials = false" :model="user" ref="user" :rules="rules" name="loginForm">
                        <el-form-item prop="login" class="my-5">
                            <label>
                                E-mail
                            </label>
                            <el-input
                                name="email"
                                type="email"
                                :class="getPrimaryColor"
                                v-model="user.login"
                                placeholder="Seu e-mail"
                                @keyup.native="validateForm"
                            />
                        </el-form-item>

                        <el-form-item prop="password" class="mt-5 mb-3">
                            <label>
                                Senha
                            </label>
                            <el-input
                                name="password"
                                data-sensitive=true
                                type="password"
                                :class="getPrimaryColor"
                                v-model="user.password"
                                placeholder="Sua senha"
                                @keyup.native="validateForm"
                                show-password
                            />
                        </el-form-item>

                        <div class="row my-4 d-flex align-items-start">
                            <div class="col-6 d-flex">
                                <InputCheckboxGroup v-model="user.checked" :items="[{label: 'Mantenha-me conectado.', value: true}]" :whitelabel="getPrimaryColor"/>
                            </div>
                            <div class="col-6 text-right d-flex align-items-start justify-content-end">

                                <router-link :class="`${getPrimaryColor} pt-0`" to="/forgot">
                                    Recuperar senha
                                </router-link>
                            </div>
                        </div>
                        <div class="w-100 c-sredfour bgc-sredone rate-limit-message" v-if="showRateLimitMessage">
                            <p class="text-center">
                                <span class="bold">
                                    Você ultrapassou o limite de 5 tentativas de login. <br>
                                </span>
                                Tente novamente em <b>30</b> segundos.
                            </p>
                        </div>
                        <Button :color="getPrimaryColor" :disabled="!formValid" @click.prevent="handleSubmit" size="large" type="submit"> Entrar </Button>
                        <p class="mt-4 c-ndarkfour">Ao fazer login, você concorda com a nossa <router-link to="/politica"  :class="`${getPrimaryColor} d-inline-block p-0 m-0`"> Política de Privacidade</router-link></p>
                        <!-- <p class="mt-4 mb-5 text-center">
                            Não possui cadastro?
                            <router-link to="/signup">
                                Crie sua conta.
                            </router-link>
                        </p> -->
                        <div class="d-flex justify-content-center align-content-center mt-4">
                            <PoweredByColorful v-if="getWhiteLabel === 'TECBAN' || getWhiteLabel === 'CIABRA'" :color="getWhiteLabel === 'CIABRA' ? '#0A735A' : '#E3001B'" />
                        </div>
                    </el-form>
                </div>
            </div>
            <SignUpImage />
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-show="$store.state.user.loading" />
    <UserWithoutCompanies :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event"/>
    <FooterSide />
    <!-- <CookiesInfo /> -->
</section>
</template>

<script>
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault';
import FooterSide from '@/components/navigation/footer/FooterSide'
import FullLoading from '@/components/loading/FullLoading'
import signIn from '@/api/signIn'
import getPartnerAssets from '@/api/getPartnerAssets'
import getUserData from '@/api/getUserData'
import jwt_decode from "jwt-decode";
import getAllCnpjs from '@/api/getAllCnpjs'
import userRules from '@/api/userRules'
import Cookies from 'js-cookie'
import UserWithoutCompanies from '@/components/modals/UserWithoutCompanies'
import PoweredByColorful from '@/components/icons/PoweredByColorful.vue'
// import CookiesInfo from '@/components/infos/CookiesInfo'
import SignUpImage from '@/views/signUp/SignUpImage.vue'


export default {
    components: {
    NavbarDefault,
    FooterSide,
    FullLoading,
    UserWithoutCompanies,
    PoweredByColorful,
    SignUpImage,
},
    data() {
        const invalidLogin = (_rule, _value, message) => {
            if (this.invalidCredetials) message('Opa! Não conhecemos este e-mail.')
            else message()
        }
        const invalidPassword = (_rule, _value, message) => {
            if (this.invalidCredetials) message('Opa! Parece que a sua senha está incorreta.')
            else message()
        }
        return {
            user: {
                login: '',
                password: '',
                partner: '',
                checked: true
            },
            rules: {
                login: [{
                        required: true,
                        message: 'Por favor, insira o seu e-mail',
                        trigger: 'change'
                    },
                    {
                        validator: invalidLogin,
                        trigger: 'change'
                    }

                ],
                password: [{
                        required: true,
                        message: 'Por favor, insira a sua senha',
                        trigger: 'change'
                    },
                    {
                        min: 6,
                        message: 'Sua senha deve ter no minimo 6 caracteres',
                        trigger: 'change'
                    },
                    {
                        validator: invalidPassword,
                        trigger: 'change'
                    }
                ]
            },
            formValid: false,
            invalidCredetials: false,
            dialogVisible: false,
            showRateLimitMessage: false
        }
    },
    methods: {
        validateForm() {
            this.$refs['user'].validate((valid) => {
                if (valid) {
                    this.formValid = true
                } else {
                    this.formValid = false
                }
            });
        },
        async handleLogin(token) {
            const result = await getUserData(token)

            if (result) {
                Cookies.set('keepConnected', this.user.checked, {
                    expires: 1,
                    domain: process.env.VUE_APP_ROOT_DOMAIN
                })

                const { cnpj, companyType, userAdm } = jwt_decode(token)

                const userCnpjsLength = this.$store.state.user.cnpjsLength

                if (userCnpjsLength == 0 && !userAdm) this.dialogVisible = true

                else if (userCnpjsLength > 1 && !cnpj || userAdm && userCnpjsLength >= 1) this.$router.push(`/company/select`)

                else if (userCnpjsLength == 1 || cnpj && companyType) {
                    this.$store.commit('user/setLoading', true)

                    await getAllCnpjs()
                    await userRules()
                    this.$store.commit('user/setToken', token)
                    this.$store.commit('user/setProfile', companyType)

                    Cookies.set('token', token, {
                        expires: 1,
                        domain: process.env.VUE_APP_ROOT_DOMAIN
                    })

                    Cookies.set('selectedCompany', cnpj, {
                        expires: 1,
                        domain: process.env.VUE_APP_ROOT_DOMAIN
                    })
                    Cookies.set('selectedProfile', companyType, {
                        expires: 1,
                        domain: process.env.VUE_APP_ROOT_DOMAIN
                    })

                    this.$store.commit('user/setLoading', false)

                    if (companyType == 0 || userAdm) window.location.href = `${this.getServiceUrls.MARKETPLACE}/opportunities`
                    if (companyType == 1) window.location.href = `${this.getServiceUrls.MARKETPLACE}/home`
                    if (companyType == 2) window.location.href = `${this.getServiceUrls.MARKETPLACE}/order/receivables`
                    if (companyType == 3) window.location.href = `${this.getServiceUrls.MARKETPLACE}/order`

                }
            }
        },
        async handleSubmit() {
            if (this.user.partner === ""){
                await this.getPartnerAssets()
                return await this.handleSubmit()
            }
            const result = await signIn(this.user)
            if (result.data.ok) {
                this.handleLogin(result.data.payload)
            } else if (result.data.status == 429){
                this.showRateLimitMessage = true
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            } else {
                this.invalidCredetials = true
                this.validateForm()
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
                this.showRateLimitMessage = false
            }
        },
        async getPartnerAssets(){
            const urlArray = window.location.host.split('-')
            let asset = urlArray[0].includes('account') || urlArray[0].includes('localhost') ? 'cashforce' : urlArray[0]
            
            if(process.env.VUE_APP_ROOT_ENVIROMENT === "local"){
                asset = process.env.VUE_APP_ROOT_USED_WHITELABEL
            }

            await getPartnerAssets(asset)
            
            const partnerAssets = JSON.parse(Cookies.get('partnerAssets'))
            this.user.partner = partnerAssets.urlName
        }
    },
    async created() {
        await this.getPartnerAssets()
        const token = Cookies.get('token')
        
        const keepConnected = JSON.parse(Cookies.get('keepConnected'))

        const { partner } = jwt_decode(token)
        const urlPartner = this.user.partner

        if (partner !== urlPartner) return

        this.user.checked = keepConnected
        if (keepConnected == true && token) {
            this.handleLogin(token)
        }
    },
}
</script>

<style scoped lang="scss">
.width-432 {
    max-width: 432px;
}
.rate-limit-message {
    border-radius: 6px;
    padding: 24px;
    margin: 32px 0px;
}
#signIn {
    .container {
        height: 100vh;
    }
}
</style>
